module.exports = __webpack_public_path__ + "img/store_vip_benefit_personal.00d7182d.png";